import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function BookCard({ book, index }) {
  return (
    <Reveal delay={index * 0.06} className="h-full">
      <article className="book-card group flex h-full flex-col overflow-hidden rounded-[2rem] border border-cocoa/10 bg-white/70 p-4 backdrop-blur-sm" data-testid={`book-card-${book.id}`}>
        <Link to={`/books/${book.slug}`} data-testid={`book-detail-image-link-${book.id}`} className="spotlight block rounded-[1.5rem] p-6" style={{ "--spot": book.accent }}>
          <div className="arch-frame mx-auto aspect-[3/4] max-w-[250px] overflow-hidden bg-white">
            <img src={book.image} alt={`${book.title} visual`} data-testid={`book-image-${book.id}`} className={`h-full w-full transition-transform duration-700 group-hover:scale-105 ${book.image_fit === "contain" ? "bg-[#F4F0E8] object-contain" : "object-cover"}`} />
          </div>
        </Link>
        <div className="flex flex-1 flex-col p-5">
          <p className="text-xs uppercase tracking-[0.25em] text-cocoa/45" data-testid={`book-mood-${book.id}`}>{book.mood}</p>
          <Link to={`/books/${book.slug}`} data-testid={`book-title-link-${book.id}`} className="mt-3 block w-fit transition-colors duration-300 hover:text-cocoa/70">
            <h3 className="font-display text-3xl leading-none" data-testid={`book-title-${book.id}`}>{book.title}</h3>
          </Link>
          <p className="mt-4 flex-1 text-sm leading-6 text-cocoa/65" data-testid={`book-description-${book.id}`}>{book.description}</p>
          {book.coming_soon ? (
            <button type="button" disabled data-testid={`book-coming-soon-button-${book.id}`} className="mt-6 w-fit cursor-not-allowed rounded-full border border-cocoa/10 bg-cocoa/5 px-5 py-2 text-sm text-cocoa/40">
              Coming soon
            </button>
          ) : (
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/contact" data-testid={`book-enquiry-link-${book.id}`} className="w-fit rounded-full border border-cocoa/15 px-5 py-2 text-sm transition-colors duration-300 hover:border-cocoa hover:bg-cocoa hover:text-white">
                Ask about it
              </Link>
              {book.buy_url && (
                <a href={book.buy_url} target="_blank" rel="noreferrer" data-testid={`book-buy-link-${book.id}`} className="w-fit rounded-full bg-cocoa px-5 py-2 text-sm text-white transition-transform duration-300 hover:scale-105">
                  Buy on Amazon
                </a>
              )}
            </div>
          )}
        </div>
      </article>
    </Reveal>
  );
}
